export default "/images/8c09d7abee15ae452b4e1e491cb04484.avif";